import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import API from "../../services/api.jsx";
import Loader from "../layout/loader.jsx";
import { toast } from "react-toastify";
import Helpers from "../../services/helpers.jsx";

class MyAccount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      breadcrumb: {},
      fields: {
        name: { label: "User name", type: "text", required: true },
        email: {
          disabled: true,
          label: "Email address",
          type: "email",
          required: true,
        },
        role: {
          label: "Role",
          type: "select",
          required: true,
          disabled: true,
          options: [],
        },
        affiliates: {
          disabled: true,
          label: "Assigned affiliate(s)",
          type: "select-multi",
          optionKey: 'affiliates',
          fullWidth: true,
          required: false,
          options: [],
        },
        clients: {
          disabled: true,
          label: "Assigned client(s)",
          type: "select-multi",
          optionKey: 'clients',
          fullWidth: true,
          required: false,
          options: [],
        },
      },
      user: null,
    };
    this.afterChange = this.afterChange.bind(this);
    this.saveEntity = this.saveEntity.bind(this);
    this.deleteEntity = this.deleteEntity.bind(this);
  }

  componentDidMount() {
    this.loadUser();
    this.loadRoleOptions();
  }

  loadUser() {
    API.getCurrentUser().then((user) => {
      const isSuperAdmin = Helpers.isSuperAdmin(user?.role?.name);
      this.setState({
        loading: false,
        user: {
          ...user,
          role: user.role.id,
          affiliates: user.affiliates.map((affiliate) => affiliate.id),
          clients: user.clients.map((client) => client.id),
        },
        fields: isSuperAdmin
          ? {
              ...this.state.fields,
              email: {
                ...this.state.fields.email,
                disabled: false,
              },
            }
          : this.state.fields,
      });
    });
  }

  loadRoleOptions() {
    API.getAvaliableOptions('roles').then((entities) => {
      const roles = entities?.roles?.map((role) => ({
        key: role.id,
        label: role.name,
      }));
      this.setState((prevState) => ({
        fields: {
          ...prevState.fields,
          role: { ...prevState.fields.role, options: roles },
        },
      }));
    });
  }

  afterChange(key, value) {
    if (key === "role") {
      API.getRole(value).then((role) => {
        if (Helpers.isClient(role?.name)) {
          this.setState((prevState) => ({
            fields: {
              ...prevState.fields,
              affiliates: {
                ...prevState.fields.affiliates,
                hidden: true,
              },
              clients: {
                ...prevState.fields.clients,
                type: "select",
              },
            },
            entity: {
              ...prevState.entity,
              affiliates: null,
              clients: null,
            },
          }));
        } else {
          this.setState((prevState) => ({
            fields: {
              ...prevState.fields,
              affiliates: {
                ...prevState.fields.affiliates,
                hidden: false,
              },
              clients: {
                ...prevState.fields.clients,
                type: "select-multi",
              },
            },
          }));
        }
      });
    }
  }

  saveEntity(fields) {
    this.setState({ loading: true });
    API.update("users", "me", fields)
      .then(() => {
        toast.success("You Account has been updated");
        this.props.history.push("/");
      })
      .catch(() => {
        // toast.error("An unexpected error has occurred, please try again");
        this.setState({ loading: false });
      });
  }

  deleteEntity() {
    this.props.history.push("/account/change-password");
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head
            title="Account"
            breadcrumb={this.state.breadcrumb}
            tabs={this.state.tabs}
          />
          <Content>
            <Form
              title="Settings"
              fields={this.state.fields}
              entity={this.state.user}
              hideCancel={true}
              save={this.saveEntity}
              canDelete={true}
              saveText={"Save changes"}
              deleteText={"Change password"}
              delete={this.deleteEntity}
              afterChange={this.afterChange}
            />
          </Content>
        </>
      );
  }
}

export default MyAccount;
